import { MSPServiceCode } from '@/modules/msp/routes/constants';

import {
  ERZServiceCode,
  ARSServiceCode,
  BIAServiceCode,
  IACServiceCode,
  PAYServiceCode,
  RMPServiceCode,
  WNTServiceCode,
  RMPCServiceCode,
} from './serviceCodes';

export enum IntegrationSystem {
  ERZ = 'erz',
  IAC = 'iac',
  RMP = 'rmp',
  RMPC = 'rmpc',
  MSP = 'msp',
  BIA = 'bia',
  PAY = 'pay',
  ARS = 'ars',
  WNT = 'wnt',
}

export enum UserRequestStatus {
  FINISHED = 'finished',
  IN_PROCESS = 'in_process',
  READY_TO_SEND = 'ready_to_send',
  PAYMENT = 'payment',
  DRAFT = 'draft',
}
export enum UserRequestChannel {
  NPU = 'npu',
  EKG = 'ekg',
  SGD = 'sgd',
}

export enum InvoiceStatus {
  CREATED = 'created',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  SUCCESS = 'success',
  ON_HOLD = 'on_hold',
}

export enum ArtifactType {
  EXTRACT = 'extract',
  RECEIPT = 'receipt',
  SIGN = 'sign',
  MESSAGE = 'message',
  APPLICATION = 'application',
  INSURANCE = 'insurance',
  BUNDLE = 'bundle',
  REFUSAL = 'refusal',
  RECEIPT_ARCHIVE = 'receipt-archive',
}

export enum CorrespondenceType {
  LEGAL_ENTITY = 'legal_entity',
  PRIVATE_PERSON = 'private_person',
}

export enum AddressCheckResult {
  MATCHED = 'matched',
  MISMATCHED = 'mismatched',
  NO_REGISTRY_DATA = 'no_registry_data',
}

export type ServiceCodeBySystem<T extends IntegrationSystem> = T extends IntegrationSystem.ERZ
  ? typeof ERZServiceCode
  : T extends IntegrationSystem.IAC
    ? typeof IACServiceCode
    : T extends IntegrationSystem.RMP
      ? typeof RMPServiceCode
      : T extends IntegrationSystem.MSP
        ? typeof MSPServiceCode
        : T extends IntegrationSystem.BIA
          ? typeof BIAServiceCode
          : T extends IntegrationSystem.PAY
            ? typeof PAYServiceCode
            : T extends IntegrationSystem.WNT
              ? typeof WNTServiceCode
              : T extends IntegrationSystem.ARS
                ? typeof ARSServiceCode
                : T extends IntegrationSystem.RMPC
                  ? typeof RMPCServiceCode
                  : null;

type NonNullableServiceCodes = Exclude<ServiceCodeBySystem<IntegrationSystem>, null>;

export type MergedServiceCodes = Flatten<UnionToIntersection<NonNullableServiceCodes>>;

export type ServiceCode = MergedServiceCodes[keyof MergedServiceCodes];

export interface SelectOption<T extends string = string> {
  id: Nullable<T>;
  label: Nullable<string>;
}
